import React, { FC, useEffect } from 'react';
import { Territory as TTerritory } from 't2-graphql-types';
import TerritoryMembershipMenu from '../TerritoryHeader/TerritoryMembershipMenu';
import { TDropdownState } from '../Dropdown/types';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';
import ProtectWithLogin from '../ProtectWithLogin/ProtectWithLogin';
import { useTerritoryDetailsModalContext } from './context/TerritoryDetailsModalContextProvider';
import { JoinTerritoryLinkButton } from '../TerritoryHeader/JoinTerritoryLinkButton';
import { useTerritoryHomePageContext } from '../TerritoryHomePageContext/TerritoryHomePageContextProvider';

type TerritoryDetailsMembershipContainerProps = {
  territory: TTerritory;
  isTerritoryHeaderLoading: boolean;
};

// TODO: temp, import doesn't work
export enum TerritoryVersionType {
  V1 = 'v1',
  V2 = 'v2',
}

export const TerritoryDetailsMembershipContainer: FC<TerritoryDetailsMembershipContainerProps> = ({
  territory,
  isTerritoryHeaderLoading,
}) => {
  const { sendEvent } = useAnalytics();
  const { handleOpenLeaveTerritoryModal } = useTerritoryDetailsModalContext();
  const { userTerritoryPermissions } = useTerritoryHomePageContext();
  useEffect(() => {
    if (userTerritoryPermissions.refetchUserData) {
      userTerritoryPermissions.refetchUserData();
    }
  }, []);

  const onTerritoryMembershipDropdownStateChange = ({ isOpen }: TDropdownState) => {
    if (isOpen) {
      sendEvent('terrritory_membership_dropdown_open', { territory_id: territory?.id });
    } else {
      sendEvent('terrritory_membership_dropdown_close', { territory_id: territory?.id });
    }
  };

  const joinTerritoryWithAnalytics = () => {
    sendEvent('territory_join_button_click', { territory_id: territory?.id });
  };

  return (
    <div className="min-h-[34px]">
      {!userTerritoryPermissions.loading && (
        <TerritoryMembershipMenu
          onStateChange={onTerritoryMembershipDropdownStateChange}
          territoryId={territory?.id}
          onLeaveTerritoryButtonClick={handleOpenLeaveTerritoryModal}
          canUpdateTerritory={userTerritoryPermissions.canUpdateTerritory}
          canUpdateTerritoryGlobally={userTerritoryPermissions.canUpdateTerritoryGlobally}
          isTerritoryMember={userTerritoryPermissions.isTerritoryMember}
          isTerritoryAdmin={userTerritoryPermissions.isTerritoryAdmin}
          territorySlug={territory?.slug || ''}
        />
      )}
      {!userTerritoryPermissions.isTerritoryMember &&
        !userTerritoryPermissions.isTerritoryAdmin &&
        !isTerritoryHeaderLoading && (
          <ProtectWithLogin>
            <JoinTerritoryLinkButton territorySlug={territory?.slug} onClick={joinTerritoryWithAnalytics} />
          </ProtectWithLogin>
        )}
    </div>
  );
};
